export default "__VITE_ASSET__rvXgsy5E__"